export default {
  header: {
    menu: '菜单',
    emergency: '牙科急诊',
    contact:'联络我们',
    nav: {
      home: '首页',
      services: '服务',
      about: '关于我们',
      contact: '联系我们',
      insurance:'保险'
    }
  },
  hero:{
    title:'欢迎来到微笑齿科诊所',
    subtitle:'您的微笑是我们的使命',
    consultation:{
      title:'体验无痛牙科。',
      subtitle:'安排您的访问。',
      subsubtitle:'在Senyum Dental Clinic 微笑齿科诊所，我们致力于不断提升我们的服务，确保每一次就诊都超出您的期望。我们诚挚邀请您体验我们的卓越护理，并与我们一同庆祝这一成就。感谢您一直以来的支持，并成为我们旅程中不可或缺的一部分！',
      cta:'联络我们吧 '
    }
  },
  logo: {
    title: 'Senyum Dental Clinic',
    subtitle: '微笑齿科诊所'
  },
  about:{
    title:'微笑齿科诊所',
    description:{
      first:'欢迎来到Senyum Dental Clinic微笑齿科诊所！在马来语中，“SENYUM”意为“微笑”，我们致力于为每位患者打造健康与自信的笑容。Senyum Dental Clinic位于吉隆坡市中心，是您值得信赖的全面牙科护理中心，适合所有年龄段的患者。',
      second:'我们经验丰富的团队在牙科行业拥有超过15年的经验，一直以来提供高品质的口腔健康服务。我们也常常受邀参与电台和电视节目、讲座及活动，解答关于智齿（智慧牙）、牙齿种植（种牙/植牙）和其他牙科问题，同时分享宝贵的见解。',
      third:'在Senyum Dental Clinic，我们注重以患者为中心的护理，创造一个温馨、舒适和充满关怀的环境，确保每位患者都能享受到个性化的治疗和卓越的关注。我们期待帮助您实现最佳的笑容！',
    },
    team:{
      profile:{
        name:'Dr Nicholas Yeo',
        role:'牙科医生',
        description:'牙科 （马来亚大学）',
      },
      title:'团队',
    },
    location:{
      title:'如何到达 Senyum Dental Clinic',
      findus:'Senyum Dental Clinic微笑齿科诊所的位置非常便利，距离吉隆坡中央车站（KL Sentral）仅需步行5分钟。您可以通过公共交通轻松到达我们这里，包括LRT、MRT、单轨铁路、巴士或火车，因为我们可以通过KL Sentral车站大楼到达，直接通往Nu Sentral购物中心。我们在这里旨在使您通往更灿烂微笑的旅程尽可能顺利和轻松。 （我们位于商场的3楼，与Harvey Norman同层；对面是Nyonya Colours餐厅)'
    },
    clinic:{
      title:'我们的诊所',
    },
    contact:{
      title:'联络我们',
      form:{
        name:'姓名',
        email:'电子邮件',
        message:'Message',
        submit:'提交'
      }
    }
  },
  services:{
    title:'我们的服务',
    description:'Senyum Dental Clinic 提供以下服务',
  },
  insurance:{
    panel: {
      title: '医疗保险公司',
      subtitle: '我们会帮您结局任何关于医疗保险事务。倘若您有任何提问，请联系我们的客服。',
    },
    title:'支持各大医疗保险公司',
    subtitle:'我们是被个大医疗保险承认的齿科诊所',
  },
  carousel: {
    slides: {
      smile: {
        alt: '开心微笑的患者',
        caption: '创造完美笑容',
        description: '体验舒适专业的牙科护理'
      },
      facility: {
        alt: '现代化诊疗室',
        caption: '先进设施',
        description: '精密治疗的先进设备'
      },
      technology: {
        alt: '先进牙科设备',
        caption: '现代科技',
        description: '最新牙科技术确保最佳效果'
      },
      record: {
        alt: '马来西亚纪录大全',
        //caption: '马来西亚纪录大全',
        //description: '我们也深感荣幸，凭借我们备受赞誉的超声波无痛洁牙（洗牙）和抛光，及牙齿美白疗程的卓越成就，荣登《马来西亚纪录大全》，获得这一殊荣。'
        caption:'',
        description:'',
      }
    }
  },
  footer:{
    address:{
      text:'联系我们',
      note:'我们在3楼，与Harvey Norman同一层；Nyonya Colors对面'
    },
    openinghours:{
      text:'营业时间',
      dailies:'每天',
      description:'每天营业，包括公共假期',
    },
    links:{
      title:'快速链接',
    }
  } 
  // ... rest of the translations remain unchanged
}